// src/config/resourceCategories.js
import { BookOpen, BookA, Hash, BookText, PenTool, FileText, Folder } from 'lucide-react';

/**
 * PREFERRED_CATEGORIES defines the categories with custom styling.
 * 
 * IMPORTANT: Category matching is CASE-SENSITIVE
 * - "Alphabet" ≠ "alphabet" ≠ "ALPHABET"
 * - Use exact spelling when tagging files in resources-data.json
 * 
 * Features:
 * - Empty categories are automatically hidden (no files = not shown)
 * - New categories not in this list appear at the end with default styling
 * - Categories are displayed in order specified by 'order' field
 */
export const PREFERRED_CATEGORIES = [
  { 
    id: 'grammar', 
    label: 'Grammar', 
    icon: BookOpen, 
    color: 'blue', 
    order: 1 
  },
  { 
    id: 'alphabet', 
    label: 'Alphabet', 
    icon: BookA, 
    color: 'purple', 
    order: 2 
  },
  { 
    id: 'numbers', 
    label: 'Numbers', 
    icon: Hash, 
    color: 'indigo', 
    order: 3 
  },
  { 
    id: 'reading', 
    label: 'Reading', 
    icon: BookText, 
    color: 'pink', 
    order: 4 
  },
  { 
    id: 'writing', 
    label: 'Writing', 
    icon: PenTool, 
    color: 'green', 
    order: 5 
  },
  { 
    id: 'worksheets', 
    label: 'Worksheets', 
    icon: FileText, 
    color: 'orange', 
    order: 6 
  },
  { 
    id: 'general', 
    label: 'General', 
    icon: Folder, 
    color: 'gray', 
    order: 7 
  }
];

/**
 * DEFAULT_CATEGORY_CONFIG is used for discovered categories
 * (categories that appear in file metadata but aren't in PREFERRED_CATEGORIES)
 */
export const DEFAULT_CATEGORY_CONFIG = {
  icon: FileText,
  color: 'gray',
  order: 999 // Appears after all preferred categories
};